module.exports = __webpack_public_path__ + "static/media/Marketino_logo.e9e7a8d0.jpg";